import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Image,
  TranslationProvider,
} from '@resy/ui-kitchen';

import Calendar from '../../../images/ic_calendar-solid_20x20.svg';
import Invite from '../../../images/icons/invite.svg';
import People from '../../../images/icons/people.svg';

export default function RSVPPending({
  confirm,
  confirmProcessing,
  matchMedia,
  reservation,
  seating,
  serviceType,
  testId,
  venueImage,
}) {
  return (
    <>
      <div className="RSVPPending">
        <div className="RSVPPending__reservation-details-container">
          <div className="RSVPPending__grid-wrapper">
            <div className="RSVPPending__text-block">
              <div className="RSVPPending__header">
                <TranslationProvider translationKey="invite_header">
                  <h2>Join the reservation?</h2>
                </TranslationProvider>
                {matchMedia?.sm && (
                <Icon className="RSVPPending__icon ResyIcon ResyIcon--invite-green" iconClass="ResyIcon ResyIcon--invite-green" component={Invite} aria-hidden="true" />
                )}
              </div>

              <div className="RSVPPending__party-details">
                {!reservation?.party?.current_user_is_host && (
                <TranslationProvider
                  translationKey="invite_subtitle"
                  translationValues={{
                    // eslint-disable-next-line camelcase
                    host: reservation?.party?.host_first_name,
                    serviceType,
                    venue: reservation.venue.name,
                  }}
                >
                  <div className="RSVPPending__invite">
                    {/* eslint-disable-next-line camelcase */}
                    {reservation?.party?.host_first_name}
                    invited you to
                    {reservation?.venue?.name}
                    .
                    RSVP to join the party, get directions, set your dining preferences, and more.
                  </div>
                </TranslationProvider>
                )}
              </div>
            </div>

            <Image className="RSVPPending__venue-image" src={venueImage} />

            <div className="RSVPPending__reservation-info">
              <div className="RSVPPending__venue-name">{reservation?.venue?.name}</div>
              <div className="RSVPPending__date">
                <Icon className="ResyIcon ResyIcon--calendar" component={Calendar} iconClass="calendar" aria-hidden="true" />
                <div>
                  <span>{reservation?.reservation?.date}</span>
                  {' '}
                  <TranslationProvider translationKey="at">
                    <span>at</span>
                  </TranslationProvider>
                  {' '}
                  {reservation?.reservation?.time}
                </div>
              </div>

              <div className="RSVPPending__guests">
                <Icon className="ResyIcon ResyIcon--people" component={People} iconClass="people" aria-hidden="true" />
                <div>
                  <span>{reservation?.reservation?.num_seats}</span>
                  {' '}
                  <TranslationProvider translationKey="guests">
                    <span>Guests</span>
                  </TranslationProvider>

                  {seating && (<>{`, ${seating}`}</>)}
                </div>
              </div>
            </div>

            <TranslationProvider translationKey="button_invite_confirm">
              <Button
                className="RSVPPending__button ResyForm__button ResyForm__button--large"
                data-test-id={`${testId}-button-accept_invite`}
                onClick={confirm}
                processing={confirmProcessing}
              >
                I&rsquo;ll be there
              </Button>
            </TranslationProvider>
          </div>
        </div>
      </div>
    </>
  );
}

RSVPPending.propTypes = {
  confirm: PropTypes.func.isRequired,
  confirmProcessing: PropTypes.bool.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  reservation: PropTypes.shape({
    links: PropTypes.shape({
      calendar: PropTypes.shape({
        google: PropTypes.string,
        ical: PropTypes.string,
        outlook: PropTypes.string,
      }),
    }),
    party: PropTypes.shape({
      current_user_confirmed: PropTypes.bool,
      current_user_is_host: PropTypes.bool,
      has_open_spots: PropTypes.bool,
      host_attendee_token: PropTypes.string,
      host_first_name: PropTypes.string,
    }),
    reservation: PropTypes.shape({
      date: PropTypes.string,
      date_time_iso: PropTypes.string,
      num_seats: PropTypes.number,
      service_type_id: PropTypes.number,
      time: PropTypes.string,
    }),
    venue: PropTypes.shape({
      contact: PropTypes.shape({
        phone: PropTypes.string,
        url: PropTypes.string,
      }),
      location: PropTypes.shape({
        coords: PropTypes.shape({
          lat: PropTypes.string,
          long: PropTypes.string,
        }),
      }),
      name: PropTypes.string,
      social: PropTypes.string,
    }),
    invite: PropTypes.shape({
      status_id: PropTypes.number,
    }),
  }).isRequired,
  seating: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  serviceType: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
  venueImage: PropTypes.string.isRequired,
};

RSVPPending.defaultProps = {
  seating: undefined,
};
